'use client'

import { createContext, ReactNode, useContext } from 'react'
import { ImportedFieldKey } from '@/app/utils/loan/loan-pdf-extract-merge'

interface LoanPdfImportValue {
    importedFields: ReadonlySet<ImportedFieldKey>
    isImported: (key: ImportedFieldKey) => boolean
    clearImported: (key: ImportedFieldKey) => void
}

const EMPTY_VALUE: LoanPdfImportValue = {
    importedFields: new Set(),
    isImported: () => false,
    clearImported: () => {},
}

const LoanPdfImportContext = createContext<LoanPdfImportValue>(EMPTY_VALUE)

export const LoanPdfImportProvider = ({ value, children }: { value: LoanPdfImportValue; children: ReactNode }) => (
    <LoanPdfImportContext.Provider value={value}>{children}</LoanPdfImportContext.Provider>
)

export const useLoanPdfImport = (): LoanPdfImportValue => useContext(LoanPdfImportContext)
